"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "slowestTargetRuns", {
    enumerable: true,
    get: function() {
        return slowestTargetRuns;
    }
});
const _formathrtime = require("@lage-run/format-hrtime");
function slowestTargetRuns(targetRuns) {
    return targetRuns.sort((a, b)=>parseFloat((0, _formathrtime.hrToSeconds)((0, _formathrtime.hrtimeDiff)(a.duration, b.duration)))).filter((run)=>run.status !== "skipped" && !run.target.hidden);
}
